import { render } from "./NotificationMenu.vue?vue&type=template&id=137d83ec&ts=true"
import script from "./NotificationMenu.vue?vue&type=script&lang=ts"
export * from "./NotificationMenu.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__